import { createElement } from '../dom/helpers.js';

/**
 * Populates an element with option content (icon + label).
 *
 * When an iconUrl is present, renders:
 *   <img src="{iconUrl}" class="option-icon-img" aria-hidden="true"> label
 * When an icon class is present, renders:
 *   <i class="{icon}" aria-hidden="true"></i> label
 * Otherwise sets plain text.
 *
 * @param {import('../../contracts/forms.js').FieldOption} opt
 * @param {HTMLElement} el
 */
export function renderOptionContent(opt, el) {
  el.textContent = '';
  if (opt.iconUrl) {
    const img = createElement('img', {
      class: 'option-icon-img',
      'aria-hidden': 'true',
    });
    img.setAttribute('src', opt.iconUrl);
    img.setAttribute('alt', '');
    el.appendChild(img);
    if (opt.label) {
      el.appendChild(document.createTextNode(' ' + opt.label));
    } else {
      const srOnly = createElement('span', { class: 'sr-only' });
      srOnly.textContent = opt.value;
      el.appendChild(srOnly);
    }
  } else if (opt.icon) {
    const icon = createElement('i', { class: opt.icon, 'aria-hidden': 'true' });
    el.appendChild(icon);
    if (opt.label) {
      el.appendChild(document.createTextNode(' ' + opt.label));
    } else {
      // Icon-only: <i> is aria-hidden, so add sr-only text fallback
      // using opt.value as last-resort accessible name.
      const srOnly = createElement('span', { class: 'sr-only' });
      srOnly.textContent = opt.value;
      el.appendChild(srOnly);
    }
  } else {
    el.textContent = opt.label;
  }
}
